export default "__VITE_ASSET__c725bbeb__"